import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Tab, Tabs } from "react-bootstrap";
import { useAlert } from "../../../context/AlertContext";
import { useLoading } from "../../../context/LoadingContext";
import { useWebsiteName } from "../../../context/WebsiteNameContext";
import { addEditServiceRequest } from "../../../commons/ServiceRequest";
import handleChangeWebsiteTab from "../../../commons/ChangeWebsiteTab";
import EditWorkOrderForm from "../../../components/GeneralJobForm/EditWorkOrderForm";
import SeqOthersJobsService from "../../../services/seqothersjob.service";

export default function EditJobNotification() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();
  const { websiteName, setWebsiteName } = useWebsiteName();

  const handleChangeTab = (key) => {
    if (key !== state?.name)
      navigate("/general_job/create", { state: { name: key } });

    handleChangeWebsiteTab({
      key: key,
      setWebsiteName,
      tabNames: {
        create: "สร้างใบแจ้งงาน",
        edit: "แก้ไขใบแจ้งงาน",
        data: "ข้อมูลใบแจ้งงาน",
        issue: "แก้ไขสถานะใบสั่งงาน"
      }
    });
  };

  const handleSubmitWorkOrder = ({ data }) => {
    data?.map(
      (
        { Id, Job_Other_Id, Job_Type_Id, Seq_Status_Id, Seq_Oth_No, Com_Code },
        idx
      ) => {
        const modifiedData = {
          Job_Other_Id,
          Job_Type_Id,
          Seq_Status_Id,
          Seq_Oth_No,
          Com_Code
        };
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: SeqOthersJobsService.editSeqOthersJobs(
            Id,
            modifiedData
          ),
          navigated: (navi) => navi && idx === data?.length - 1 && navigate(0)
        });
      }
    );
  };

  useEffect(() => handleChangeTab(state?.name || "create"), []);

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Create a job notification Page" />
      </Helmet>

      <Container fluid className="p-0">
        <Tabs
          justify
          defaultActiveKey={state?.name || "create"}
          onSelect={(k) => handleChangeTab(k)}
        >
          <Tab eventKey="create" title="สร้างใบแจ้งงาน"></Tab>
          <Tab eventKey="edit" title="แก้ไขใบแจ้งงาน"></Tab>
          <Tab eventKey="data" title="ข้อมูลใบแจ้งงาน"></Tab>
          <Tab eventKey="issue" title="สร้างใบสั่งงาน">
            {websiteName === "แก้ไขสถานะใบสั่งงาน" && (
              <EditWorkOrderForm onSubmitCallback={handleSubmitWorkOrder} />
            )}
          </Tab>
        </Tabs>
      </Container>
    </>
  );
}
